
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconsCalendar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 20,
  height: 20,
  textRendering: "geometricPrecision",
  viewBox: "0 0 20 20"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
  id: "icons-calendar_d4e22a35b79c7a36__a",
  width: 20,
  height: 20,
  x: 0,
  y: 0,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAkFBMVEVMaXH///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+X6JXfAAAAMHRSTlMAx8H0u0DAwvUgWwr2zfdp5hnMWrUe0F/Jv7Fww+NYpXmkmdrScZyI037UkY7VhVzuCaYmAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAeUlEQVR42tXRSRLCUAhF0ReJ+V8gJrHvYxP7bv+7E6eoC/AMKOqOqAL4Yb4BjjfgsAZm43cZMuc75tOF+d4wLzPuV5gqdYkoRhu2qJIOEBZSbEXOD5HrXqReySRFyNvOyKJGz2LScXoWW/7C5I9imTlliiJ8eH79xQtAEAhz03g3fgAAAABJRU5ErkJggg==",
  width: 20,
  height: 20,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAkFBMVEVMaXH///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+X6JXfAAAAMHRSTlMAx8H0u0DAwvUgWwr2zfdp5hnMWrUe0F/Jv7Fww+NYpXmkmdrScZyI037UkY7VhVzuCaYmAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAeUlEQVR42tXRSRLCUAhF0ReJ+V8gJrHvYxP7bv+7E6eoC/AMKOqOqAL4Yb4BjjfgsAZm43cZMuc75tOF+d4wLzPuV5gqdYkoRhu2qJIOEBZSbEXOD5HrXqReySRFyNvOyKJGz2LScXoWW/7C5I9imTlliiJ8eH79xQtAEAhz03g3fgAAAABJRU5ErkJggg==",
  preserveAspectRatio: "none",
  style: {
    imageRendering: "crisp-edges"
  }
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  mask: "url(#icons-calendar_d4e22a35b79c7a36__a)",
  shapeRendering: "crispEdges",
  d: "M0 0h20v20H0z"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"20\" height=\"20\" text-rendering=\"geometricPrecision\" viewBox=\"0 0 20 20\"><defs><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAn1BMVEVMaXGQN+eMNOiPM+qQN+eQNOuQN+ePNOiQN+eQMu+QN+eDMfiNN+eQN+eQN+eQN+eYPOyQN+eQN+eNN+ePN+uQN+eNN+eQN+eMNOiTN+eNN+eQN+eNN+eQN+eNN+eaNOuQN+eROeaSNOiNN+eNN+eNN+eNN+eQNemQN+eQN+eQN+eNN+eQN+eQNemQN+eNN+eQN+eNN+eNN+ePNOiSNOg8jlliAAAANXRSTlMAx8Fbu0DAwvUg9Ar29vfmGcxatR7QX8nNv8Cxw3DjWKV5zWmk9NJx2pyZiIV+047V1JFcaVA2nQcAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAAB7SURBVHja1dFHEsIwEETRNmOQmJEDOTmAyTne/2yI7WAOwFv+VVc18EO+Ao5XYL8AZsNP6RNVO6LLnei2ISqm1E0xiTheM1vLzDGzi9j1YDJZHkTOJ5HHVmReyiiEGTeVgY/Oaj4GbaXjY0MvDP4oJi0lCfEyX561X7wBIR8JPJrRBUgAAAAASUVORK5CYII=\" id=\"convert2-source\" width=\"20\" height=\"20\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAn1BMVEVMaXGQN+eMNOiPM+qQN+eQNOuQN+ePNOiQN+eQMu+QN+eDMfiNN+eQN+eQN+eQN+eYPOyQN+eQN+eNN+ePN+uQN+eNN+eQN+eMNOiTN+eNN+eQN+eNN+eQN+eNN+eaNOuQN+eROeaSNOiNN+eNN+eNN+eNN+eQNemQN+eQN+eQN+eNN+eQN+eQNemQN+eNN+eQN+eNN+eNN+ePNOiSNOg8jlliAAAANXRSTlMAx8Fbu0DAwvUg9Ar29vfmGcxatR7QX8nNv8Cxw3DjWKV5zWmk9NJx2pyZiIV+047V1JFcaVA2nQcAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAAB7SURBVHja1dFHEsIwEETRNmOQmJEDOTmAyTne/2yI7WAOwFv+VVc18EO+Ao5XYL8AZsNP6RNVO6LLnei2ISqm1E0xiTheM1vLzDGzi9j1YDJZHkTOJ5HHVmReyiiEGTeVgY/Oaj4GbaXjY0MvDP4oJi0lCfEyX561X7wBIR8JPJrRBUgAAAAASUVORK5CYII=\" preserveAspectRatio=\"none\"/><mask id=\"layer-0\" width=\"20\" height=\"20\" x=\"0\" y=\"0\" mask-type=\"alpha\" maskUnits=\"userSpaceOnUse\"><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAkFBMVEVMaXH///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+X6JXfAAAAMHRSTlMAx8H0u0DAwvUgWwr2zfdp5hnMWrUe0F/Jv7Fww+NYpXmkmdrScZyI037UkY7VhVzuCaYmAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAeUlEQVR42tXRSRLCUAhF0ReJ+V8gJrHvYxP7bv+7E6eoC/AMKOqOqAL4Yb4BjjfgsAZm43cZMuc75tOF+d4wLzPuV5gqdYkoRhu2qJIOEBZSbEXOD5HrXqReySRFyNvOyKJGz2LScXoWW/7C5I9imTlliiJ8eH79xQtAEAhz03g3fgAAAABJRU5ErkJggg==\" width=\"20\" height=\"20\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAkFBMVEVMaXH///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+X6JXfAAAAMHRSTlMAx8H0u0DAwvUgWwr2zfdp5hnMWrUe0F/Jv7Fww+NYpXmkmdrScZyI037UkY7VhVzuCaYmAAAACXBIWXMAAAPoAAAD6AG1e1JrAAAAeUlEQVR42tXRSRLCUAhF0ReJ+V8gJrHvYxP7bv+7E6eoC/AMKOqOqAL4Yb4BjjfgsAZm43cZMuc75tOF+d4wLzPuV5gqdYkoRhu2qJIOEBZSbEXOD5HrXqReySRFyNvOyKJGz2LScXoWW/7C5I9imTlliiJ8eH79xQtAEAhz03g3fgAAAABJRU5ErkJggg==\" preserveAspectRatio=\"none\" style=\"image-rendering:crisp-edges\"/></mask></defs><rect width=\"20\" height=\"20\" fill=\"var(--theme-primary, #810ea9)\" mask=\"url(#layer-0)\" shape-rendering=\"crispEdges\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icons-calendar.d4e22a35b79c7a36f754d0e037885164.svg"),
        {
          React: SvgIconsCalendar,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      